<template>
  <div
    class="rounded-md bg-white shadow-xs"
    role="menu"
    aria-orientation="vertical"
    aria-labelledby="user-menu"
  >
    <a
      v-for="item in list"
      :key="item"
      href="#"
      class="block px-4 py-2 text-sm text-cool-gray-700 hover:bg-cool-gray-100 transition ease-in-out duration-150"
      role="menuitem"
      @click="itemAction(item)"
    >{{ item }}</a>
  </div>
</template>

<script>

export default {

  components: {
  },

  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {

    };
  },

  methods: {
    itemAction(item) {
      this.$emit('click', item);
    },
  },

};
</script>
